var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewReadingListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_5003_2",
    "data-name": "Component 5003 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16652",
    "data-name": "Path 16652",
    d: "M10.217,5.776a8.158,8.158,0,0,1,7.39,4.883,8.158,8.158,0,0,1-7.39,4.883,8.158,8.158,0,0,1-7.39-4.883,8.158,8.158,0,0,1,7.39-4.883m0-1.776A9.94,9.94,0,0,0,1,10.659a9.94,9.94,0,0,0,9.217,6.659,9.94,9.94,0,0,0,9.217-6.659A9.94,9.94,0,0,0,10.217,4Zm0,4.439a2.161,2.161,0,0,1,2.095,2.22,2.161,2.161,0,0,1-2.095,2.22,2.161,2.161,0,0,1-2.095-2.22,2.161,2.161,0,0,1,2.095-2.22m0-1.776a3.894,3.894,0,0,0-3.771,4,3.894,3.894,0,0,0,3.771,4,3.894,3.894,0,0,0,3.771-4A3.894,3.894,0,0,0,10.217,6.664Z",
    transform: "translate(9 7)",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReadingListIcon);
export default __webpack_public_path__ + "static/media/view-reading-list-icon.aa60a899725d7d2558157c946489bebe.svg";
export { ForwardRef as ReactComponent };